// useLoading.js
import { useState, useEffect } from "react";

function useLoading(delay = 2000) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Set loading to false after the specified delay
    }, delay);

    return () => clearTimeout(timer); // Cleanup
  }, [delay]);

  return isLoading;
}

export default useLoading;
